const UNIDADES = ['zero', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove'];
const DEZENAS = ['', 'dez', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa'];
const ESPECIAIS = ['dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove'];
const CENTENAS = ['', 'cento', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos', 'seiscentos', 'setecentos', 'oitocentos', 'novecentos'];

export function numeroParaExtenso(valor: number): string {
    if (valor < 0) valor = 0;
    if (valor > 999999999999.99) valor = 999999999999.99;
    const inteiro = Math.floor(valor);
    const centavos = Math.round((valor - inteiro) * 100);

    const extensoInteiro = inteiro > 0 ? converteNumero(inteiro) + (inteiro === 1 ? ' real' : ' reais') : '';
    const extensoCentavos = centavos > 0 ? converteNumero(centavos) + (centavos === 1 ? ' centavo' : ' centavos') : '';
    
    return [extensoInteiro, extensoCentavos].filter(Boolean).join(' e ') || 'zero reais';
}

function converteNumero(valor: number): string {

    if (valor < 10) return UNIDADES[valor];
    if (valor < 20) return ESPECIAIS[valor - 10];
    if (valor < 100) {
        return DEZENAS[Math.floor(valor / 10)] + (valor % 10 ? ' e ' + UNIDADES[valor % 10] : '');
    }
    if (valor < 1000) {
        return (valor === 100 ? 'cem' : CENTENAS[Math.floor(valor / 100)] + (valor % 100 ? ' e ' + converteNumero(valor % 100) : ''));
    }
    if (valor < 1000000) {
        return converteMilhares(valor);
    }
    if (valor < 1000000000) {
        return converteMilhoes(valor);
    }
    if (valor < 1000000000000) {
        return converteBilhoes(valor);
    }
    return converteTrilhoes(valor);
}

function converteMilhares(valor: number): string {
    const milhares = Math.floor(valor / 1000);
    const resto = valor % 1000;
    let resultado = milhares === 1 ? 'mil' : converteNumero(milhares) + ' mil';
    if (resto) resultado += (resto < 100 ? ' e ' : ' ') + converteNumero(resto);
    return resultado;
}

function converteMilhoes(valor: number): string {
    const milhoes = Math.floor(valor / 1000000);
    const resto = valor % 1000000;
    let resultado = milhoes === 1 ? 'um milhão' : converteNumero(milhoes) + ' milhões';
    if (resto) resultado += (resto < 100 ? ' e ' : ' ') + converteNumero(resto);
    return resultado;
}

function converteBilhoes(valor: number): string {
    const bilhoes = Math.floor(valor / 1000000000);
    const resto = valor % 1000000000;
    let resultado = bilhoes === 1 ? 'um bilhão' : converteNumero(bilhoes) + ' bilhões';
    if (resto) resultado += (resto < 100 ? ' e ' : ' ') + converteNumero(resto);
    return resultado;
}

function converteTrilhoes(valor: number): string {
    const trilhoes = Math.floor(valor / 1000000000000);
    const resto = valor % 1000000000000;
    let resultado = trilhoes === 1 ? 'um trilhão' : converteNumero(trilhoes) + ' trilhões';
    if (resto) resultado += (resto < 100 ? ' e ' : ' ') + converteNumero(resto);
    return resultado;
}